<template>
  <div>
    <v-container class="pa-0 ma-0">
      <v-progress-circular v-if="isLoading" model-value="20"></v-progress-circular>
      <v-container
        v-if="!isLoading"
        class="pa-0 ma-0 payment-page d-flex flex-column align-center"
      >
        <!-- Header-->
        <v-container
          class="ma-0 payment-header d-flex align-center justify-space-between pa-0"
        >
          <v-card-text class="header-title">{{ $t("finally checkout") }}</v-card-text>
          <v-btn
            outlined
            @click="$emit('close')"
            class="me-2 pa-0"
            color="primary"
            height="32"
          >
            <p class="font-weight-thin mb-0 pa-0">
              {{ $t("return-to-previous-page") }}
            </p>
            <!-- <v-icon small color="gary"> mdi-refresh </v-icon> -->
          </v-btn>
          <!-- <v-icon class="pl-2 back-icon" @click="$emit('close')">mdi-chevron-left</v-icon> -->
        </v-container>
        <!-- content -->
        <v-container class="px-2 ma-0 d-flex flex-column gap-4 payment-body flex-grow-1">
          <!-- btn customer info -->
          <v-container v-if="!mobile" class="pa-0 ma-0">
            <v-btn
              outlined
              color="primary"
              class="customer-btn w-100"
              @click="customerDialog = true"
              >{{ $t("add user information") }}</v-btn
            >
          </v-container>
          <!-- btn edit phone number  -->
          <v-container
            v-if="mobile"
            class="d-flex align-center gap-3 pa-0 ma-0"
            style="width: 100%"
          >
            <!-- mobile box -->
            <v-container class="d-flex align-center justify-space-between edit-mobile">
              <!-- user icon -->
              <v-icon small color="#888">mdi-account-outline</v-icon>
              <!-- mobile text -->
              <v-card-text>{{ mobile }}</v-card-text>
              <!-- clear button -->
              <v-icon small class="mr-2" @click="mobile = ''">mdi-close</v-icon>
            </v-container>
            <!-- edit button -->
            <v-btn
              outlined
              color="#0065FC"
              height="42"
              class="px-6"
              @click="customerDialog = true"
            >
              {{ $t("edit") }}
            </v-btn>
          </v-container>
          <!-- dialog add customer info -->
          <v-dialog
            v-model="customerDialog"
            width="380px"
            class=""
            transition="dialog-transition"
          >
            <v-card class="d-flex flex-column gap-4 pa-3 ma-0">
              <v-form class="d-flex flex-column gap-4 pa-3 ma-0" ref="customerForm">
                <!-- title -->
                <v-card-text class="text-right pa-0 ma-0 dialog-title">{{
                  $t("user infromation")
                }}</v-card-text>
                <!-- subtitle -->
                <v-card-text class="pa-0 ma-0 text-right dialog-subtitle">
                  {{ $t("Enter your information to receive SMS") }}
                </v-card-text>
                <!-- phone number -->
                <v-text-field
                  v-model="mobile"
                  class="rtl-text"
                  hide-details="auto"
                  clearable
                  outlined
                  height="42"
                  :label="$t('mobile')"
                  :rules="[mobileFormatRule]"
                />
                <!-- name & last name -->
                <div class="d-flex gap-3 my-2">
                  <v-text-field
                    v-model="firstName"
                    outlined
                    :label="$t('name')"
                    class="rtl-text"
                    hide-details="auto"
                    clearable
                    height="42"
                    :rules="[(v) => !!v || $t('isRequired')]"
                  ></v-text-field>
                  <v-text-field
                    v-model="lastName"
                    outlined
                    :label="$t('last-name')"
                    class="rtl-text"
                    hide-details="auto"
                    clearable
                    height="42"
                    :rules="[(v) => !!v || $t('isRequired')]"
                  ></v-text-field>
                </div>

                <!--nationalCode  -->
                <v-text-field
                  v-model="nationalCode"
                  outlined
                  :label="$t('national-code')"
                  class="rtl-text"
                  hide-details="auto"
                  clearable
                  height="42"
                  :rules="[
                    (v) => /^[0-9]*$/.test(v) || $t('only numbers allowed'),
                    (v) => !v || v.length <= 10 || $t('max-10-item'),
                  ]"
                  @keydown.enter.prevent="submitCustomerInfo()"
                />

                <!-- close btn & submit btn -->
                <v-container class="pa-0 ma-0 d-flex justify-space-between gap-2">
                  <v-btn
                    :loading="loading"
                    color="#007bff"
                    class="white--text"
                    height="42"
                    @click="submitCustomerInfo()"
                  >
                    {{ $t("save information") }}
                  </v-btn>
                  <v-btn
                    outlined
                    height="42"
                    color="black"
                    class=""
                    @click="customerDialog = false"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                </v-container>
              </v-form>
            </v-card>
          </v-dialog>

          <!--  detils peyment -->
          <v-container class="pa-0 ma-0 section-box">
            <!--  total amount -->
            <v-row
              no-gutters
              class="px-2 py-3 ma-0 d-flex justify-space-between align-center"
              style="width: 100%"
            >
              <v-col class="gray-label" cols="auto">{{
                $t("total Amount Without tax")
              }}</v-col>
              <v-col class="value-text" cols="auto">
                {{ $numberFormat(totalPrice) }} {{ $store.state.currency.name }}
              </v-col>
            </v-row>
            <!-- discount -->
            <v-row
              no-gutters
              class="px-2 ma-0 py-3 d-flex justify-space-between align-center"
              style="width: 100%"
            >
              <v-col class="gray-label" cols="auto">{{ $t("discount") }}</v-col>
              <v-col class="value-text" cols="auto"
                >۰ {{ $store.state.currency.name }}</v-col
              >
            </v-row>
            <!-- tax -->
            <v-row
              no-gutters
              class="px-2 ma-0 py-3 d-flex justify-space-between align-center"
              style="width: 100%"
            >
              <v-col class="gray-label" cols="auto">{{ $t("total Amount With tax") }}</v-col>
              <v-col class="value-text" cols="auto">
                {{ $numberFormat(tax) }} {{ $store.state.currency.name }}
              </v-col>
            </v-row>
            <!-- total price for pay -->
            <v-row
              no-gutters
              class="pa-0 ma-0 py-3 d-flex justify-space-between align-center total-line"
              style="width: 100%"
            >
              <v-col class="total-label px-2" cols="auto"
                >{{ $t("amountForPay") }}
              </v-col>
              <v-col class="text-primary px-2" cols="auto">
                {{ $numberFormat(payAmount) }} {{ $store.state.currency.name }}
              </v-col>
            </v-row>
          </v-container>

          <!-- choose select pay way  -->
          <v-container v-if="!isPresell" class="pa-0 ma-0">
            <v-card-text class="section-title mb-3 pa-0 px-1 ma-0">{{
              $t("select payment way")
            }}</v-card-text>

            <!-- pay on site  -->
            <v-sheet
              v-if="isOfflineActive"
              class="pa-0 ma-0 payment-method d-flex align-center px-4 py-3 mb-2"
              outlined
            >
              <v-icon size="20" color="#000000">mdi-credit-card</v-icon>
              <v-container class="pa-0 ma-0 d-flex flex-column pr-3">
                <v-card-text class="pa-0 ma-0 method-title">{{
                  $t("paymentinplace")
                }}</v-card-text>
                <small class="pa-0 ma-0 gray-hint">{{ $t("Portable POS") }}</small>
              </v-container>
            </v-sheet>

            <!--  pey internet -->
            <v-sheet
              v-if="isOnlineActive"
              class="pa-0 ma-0 payment-method d-flex align-center px-4 py-3 mb-2"
              outlined
            >
              <img src="@/assets/shopping/samanLogo.png" contain height="20" width="20" />
              <v-container class="pa-0 ma-0 d-flex flex-column pr-3">
                <v-card-text class="pa-0 ma-0 method-title">{{
                  $t("Online Payment")
                }}</v-card-text>
                <small class="pa-0 ma-0 gray-hint">{{ saman }}</small>
              </v-container>
            </v-sheet>
          </v-container>
        </v-container>

        <!--  Footer btn pay  -->
        <v-container
          class="pa-0 ma-0 payment-footer d-flex align-center justify-space-between pa-3"
        >
          <v-container class="pa-0 ma-0 footer-amount font-weight-bold">
            {{ $numberFormat(payAmount) }} {{ $store.state.currency.name }}</v-container
          >
          <v-btn
            :loading="loading"
            color="#00664D"
            class="pay-btn mr-3"
            @click="handlePayment()"
          >
            {{
              isPresell
                ? $t("Submit Invoice")
                : isOfflineActive
                ? $t("pey-the-amount")
                : $t("Online Payment")
            }}
          </v-btn>
        </v-container>
        <!--  snackbar --->
        <v-snackbar
          v-if="snakbar"
          v-model="snakbar"
          :color="snakbarColor ? snakbarColor : 'primary'"
          top
          style="z-index: 1000000000000 !important"
        >
          {{ snakbarText }}

          <template v-slot:action="{ attrs }">
            <v-btn
              :loading="loading"
              color="white"
              text
              v-bind="attrs"
              @click="snakbar = !snakbar"
            >
              {{ $t("close") }}
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-container>
    <!--print-->
    <div ref="refPrint" style="display: none">
      <index-print
        :account-prop="customerName"
        :date-prop="submitInvoiceDate"
        :items-prop="productItems"
        :sum-prop="productItems[0].product.finalPrice"
        :total-discount="productItems[0].product.discount"
        :total-tax="productItems[0].product.totalTax"
        :id-prop="idPrint"
        :number-prop="invoiceNumber"
        :status-prop="'print'"
        :content-prop="Content"
      />
    </div>
  </div>
</template>

<script>
import Mixin from "@/Mixins/mixin";
import general from "@/Mixins/general";
import print from "@/views/dashboard/components/general/printViewer/printViewer.vue";
import indexPrint from "@/views/dashboard/pages/invoice/indexCategoryPrint.vue";

export default {
  name: "PaymentConfirmPage",
  mixins: [Mixin, general],
  props: {
    cartItems: { type: Array, required: true },
    totalPerProduct: { type: Array, required: true },
    totalPrice: { type: Number, required: true },
    paymentObject: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      saman: "سامان",
      customerDialog: false,
      loading: false,
      isLoading: false,
      submitSuccessInvoice: null,
      mobile: "",
      firstName: "",
      lastName: "",
      nationalCode: "",
      mobileFormatRule: null,
      finID: null,
      accountID: null,
      name: null,
      currency: null,
      currencyAmount: null,
      formattedDate: null,
      entrepotID: null,
      discount: null,
      type: null,
      Content: null,
      totalTax: null,
      items: [],
      invoiceData: [],
      submitInvoiceDate: null,
      customerName: null,
      idPrint: null,
      invoiceNumber: null,
      socketPrintRes: null,
      selectedPrinter: null,
      snakbar: false,
      snakbarColor: null,
      snakbarText: null,
    };
  },
  components: {
    indexPrint,
    print,
  },
  computed: {
    productItems() {
      return this.cartItems.map((item, index) => {
        const total = this.totalPerProduct[index] ?? 0;

        return {
          product: {
            ...item,
            totalPerProduct: total,
            discount: 0,
            taxPerProduct: total * 0.1,
            totalTax: this.tax,
            finalPrice: this.payAmount,
          },
        };
      });
    },
    numericPrice() {
      const val = Number(String(this.totalPrice).replace(/,/g, ""));
      return isNaN(val) ? 0 : val;
    },
    tax() {
      const value = this.numericPrice * 0.1;
      return Math.round(value);
    },
    payAmount() {
      return this.numericPrice + this.tax;
    },
    //peyment conditions
    isPresell() {
      return this.paymentObject?.invoiceType == "presell";
    },
    isOfflineActive() {
      return this.paymentObject?.offlinePayment == "active";
    },
    isOnlineActive() {
      return this.paymentObject?.onlinePayment == "active";
    },
  },
  mounted() {
    function toJalali(date = new Date()) {
      const f = new Intl.DateTimeFormat("fa-IR-u-nu-latn", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      return f.format(date).replace(/-/g, "/");
    }
    this.formattedDate = toJalali();
    this.mobileFormatRule = (value) => {
      const regex = /^(\+98|0)?9\d{9}$/;
      return regex.test(value) ? true : this.$t("invalid mobile format");
    };

    if (localStorage.getItem("selectedPrinter")) {
      this.selectedPrinter = localStorage.getItem("selectedPrinter");
    }
  },
  methods: {
    submitCustomerInfo() {
      const app = this;
      app.loading = true;
      const validMobile = this.mobileFormatRule(this.mobile);
      const Valid = this.$refs.customerForm.validate();
      if (validMobile !== true || !Valid) {
        console.log("break");
        app.loading = false;
        return;
      } else {
        app.$axios
          .post(app.$endpoint + "customer", {
            mobile: app.mobile,
            firstname: app.firstName,
            lastname: app.lastName,
            nationalCode: app.nationalCode,
          })
          .then((response) => {
            //set peyload items from respponse & store & paymentObject
            app.finID = response.data.data.fin_id;
            app.accountID = response.data.data.id;
            app.name = response.data.data.name;
            app.currency = app.$store.state.currency;
            app.currencyAmount = app.$store.state.currency.amount;
            app.entrepotID = app.paymentObject.entrepotId;
            app.type = app.paymentObject.invoiceType;
            app.items = app.cartItems.map((p) => ({
              product: { id: p.id },
              fee: Number(String(p.price).replace(/,/g, "")),
              count: Number(p.count),
              unit: { id: p.unit_id || 1 },
              discount: 0,
              tax: app.tax,
              content: app.paymentObject.content,
            }));
            //create an object for call peyment
            app.invoiceData = {
              account: {
                id: app.accountID,
                fin_id: app.finID,
                name: app.name,
              },
              // currency: {
              //   id: app.currency.id,
              // },
              currency_amount: app.currencyAmount,
              entrepot: { id: app.entrepotID },
              type: app.type,
              date: app.formattedDate,
              content: app.paymentObject.content,
              discount: 0,
              tax: app.tax,
              items: app.items,
            };
            app.loading = false;
            app.customerDialog = false;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            app.loading = false;
          });
      }
    },
    handlePayment() {
      var app = this;
      app.loading = true;
      if (!app.accountID || !app.finID) {
        app.snakbarText = app.$t("please enter your info");
        app.snakbarColor = "red";
        app.snakbar = true;
        app.loading = false;
        return;
      }
      app.$axios
        .post(app.$endpoint + "invoice", app.invoiceData)
        .then((response) => {
          localStorage.removeItem("selectedProduct");
          const Success = {
            id: response.data.data.id,
            uid: response.data.data.uid,
          };
          app.submitSuccessInvoice = Success;

          if (response.data.status == "success") {
            app.idPrint = response.data.data.id;
            app.invoiceNumber = response.data.data.number;
            app.customerName = response.data.data.account;
            app.submitInvoiceDate = response.data.data.date;

            // if (app.selectedPrinter == undefined || app.selectedPrinter == null) {
              // app.snakbarText = app.$t("first set your printer");
              // app.snakbarColor = "red";
              // app.snakbar = true;
            // } else {
              // console.log(
              //   app.idPrint +
              //     "///" +
              //     app.invoiceNumber +
              //     "///" +
              //     app.customerName +
              //     "///" +
              //     app.submitInvoiceDate
              // );
              app.print("create");
            // }
          } else {
            app.snakbarText = app.$t("invoice didn't submit succesfully!");
            app.snakbarColor = "red";
            app.snakbar = true;
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
          app.loading = false;
        })
        .finally(() => {
          localStorage.removeItem("selectedProduct");
          app.loading = false;
          app.isLoading = false;
        });
    },
    print(type) {
      const socket = new WebSocket("ws://127.0.0.1:8145/Print");
      socket.onopen = () => {
        var body = this.$refs.refPrint.innerHTML;
        var html =
          '<!DOCTYPE html><html><meta charset="utf-8"><head>' +
          "<style scoped>" +
          "  thead > tr > td{border: 2px solid black;padding: 5px;font-size: 9px}" +
          "  tbody > tr > td{border: 2px solid black;padding: 5px;font-size: 9px}" +
          "  tfoot > tr > td{border: 2px solid black;padding: 5px;font-size: 9px}" +
          "@font-face {" +
          '  font-family: "IRANSans(FaNum)";' +
          '  src: url("https://abr.abriron.com/font/IRANSans(FaNum).ttf") format("truetype");' +
          "}" +
          '  body{font-family: "IRANSans(FaNum)";}' +
          "@page {" +
          "    padding: 0mm;" +
          "    margin: 0mm;" +
          " }" +
          " @media print {" +
          "    margin: 0mm; padding: 0mm;" +
          "}" +
          "" +
          "</style>" +
          "" +
          "</head>" +
          '<body style="direction: rtl;">' +
          body +
          "</body>" +
          "</html>";

        const message = {
          Data: html,
          PrinterName: this.selectedPrinter,
        };
        socket.send(JSON.stringify(message));

        socket.onmessage = (event) => {
          this.socketPrintRes = {
            status: event.data,
            timestamp: Date.now(),
            type: type ? type : "create",
          };
          this.$emit("SuccessObject", this.submitSuccessInvoice);
        };
      };
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field--outlined .v-label {
  top: 11px !important;
}
.payment-page {
  min-height: 100vh;
  direction: rtl;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

.payment-header {
  height: 60px;
  border-bottom: 1px solid #eaeaea;
  background-color: #fff;
}
.header-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
}
.back-icon {
  font-size: 36px;
  color: #1a1a1a;
  cursor: pointer;
}

.section-box {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
}
.gray-label {
  font-size: 14px;
  color: #666;
}
.value-text {
  font-size: 14px;
  font-weight: 600;
  color: #222;
}
.add-code-btn {
  font-size: 13px;
  border-radius: 8px;
  font-weight: 600;
  padding: 4px 12px;
  margin-right: 2px;
}
.customer-btn {
  font-weight: 600;
  font-size: 14px;
  border-radius: 4px;
}
.total-line {
  border-top: 1px solid #007bff;
}
.total-label {
  font-size: 14px;
  font-weight: 600;
}
.section-title {
  font-weight: 600;
  font-size: 15px;
  color: #333;
}
.payment-method {
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 10px 12px;
  transition: all 0.25s ease;
}
.method-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}
.gray-hint {
  font-size: 12px;
  color: #999;
}
.payment-footer {
  border-top: 1px solid #e6e6e6;
  background-color: #fff;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.06);
  font-size: 15px;
  color: #1a1a1a;
}
.pay-btn {
  font-weight: 600;
  font-size: 14px;
  height: 46px;
  max-width: 150px;
}
.customer-dialog-card {
  border-radius: 8px;
}

.dialog-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a1a;
}

.dialog-subtitle {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}
.edit-mobile {
  background: white;
  border-radius: 12px;
  padding: 0 12px;
  height: 45px;
  width: 100%;
  border: 1px solid #e5e5e5;
}
</style>
